import NoResultsForm from '../pages/hull/components/no-results-form'

import styles from './styles.module.css'

const NoResults = ({ address, currentProvider }) => (
  <div className={styles.noResultsFormWrapper}>
    <div className={styles.noResultsContent}>
      <h2>Be the first to hear about new broadband deals</h2>
      <p>
        New providers are rolling out across your area, but we don't have deals for you just yet. Register now to be
        updated when they arrive!
      </p>
    </div>

    <div className={styles.noResultsFormContainer}>
      <NoResultsForm
        customerAddress={address}
        provider={currentProvider}
        isFetchingAddress={false}
        uprn={address.uprn}
      />
    </div>
  </div>
)

export default NoResults
